import { render, staticRenderFns } from "./AttendanceDialogTable.vue?vue&type=template&id=4b593a8b"
import script from "./AttendanceDialogTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttendanceDialogTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports